import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import routes from '../../../../routing/routes';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import { updateLegalneDefinicie } from '../../../../client/termin/terminLegalneDefinicieUpdateClient';
import Definicia from '../../../../model/Definicia';
import LegalneDefinicieUpdateForm from './component/LegalneDefinicieUpdateForm';
import { technickePricinyErrorStatus } from '../../../../constants/ErrorConstant';

interface Props {
  initialDefinicie: Array<Definicia>;
}

const LegalneDefinicieUpdate = ({ initialDefinicie }: Props): ReactElement => {
  const { tezaurusUuid, terminUuid } = useParams<{ tezaurusUuid: string, terminUuid: string }>();
  const [legalneDefinicie, setLegalneDefinicie] = useState(initialDefinicie);

  const {
    wrapClient: updateLegalneDefinicieClient,
    status: updateTerminStatus,
  } = useClient(updateLegalneDefinicie);

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const { handleStatus } = useClientStatusContext();

  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
    clearAllFieldErrorMessages,
  } = useFieldErrorMessages();

  const handleSubmit = async (event): Promise<void> => {
    event.preventDefault();
    await updateLegalneDefinicieClient(terminUuid, legalneDefinicie);
    navigate(routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (updateTerminStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [updateTerminStatus, handleStatus]);

  return (
    <LegalneDefinicieUpdateForm
      legalneDefinicie={legalneDefinicie}
      setLegalneDefinicie={setLegalneDefinicie}
      onSubmit={handleSubmit}
      getFieldErrorMessage={getFieldErrorMessage}
      clearFieldErrorMessage={clearFieldErrorMessage}
      clearAllFieldErrorMessages={clearAllFieldErrorMessages}
      loading={updateTerminStatus.loading}
    />
  );
};

export default LegalneDefinicieUpdate;
